import { useEffect, useState } from "react";
import { useFlags } from "launchdarkly-react-client-sdk";
import moment from "moment";

import { VoeBizApi } from "../../services/api";

import { IFlightOrder } from "../../@types/flight-order";

export function useModal() {
  const brazilFormatDate = `YYYY/MM/DD`;

  const [modal, setModal] = useState({
    isOpenDetail: false,
    isOpenFilter: false,
    period: "NO_INTERVAL",
    filter: {
      LAST_7_DAYS: {
        startDate: moment().subtract("7", "d").format(brazilFormatDate),
        endDate: moment().format(brazilFormatDate),
      },
      LAST_15_DAYS: {
        startDate: moment().subtract("15", "d").format(brazilFormatDate),
        endDate: moment().format(brazilFormatDate),
      },
      LAST_30_DAYS: {
        startDate: moment().subtract("30", "d").format(brazilFormatDate),
        endDate: moment().format(brazilFormatDate),
      },
      NEXT_7_DAYS: {
        endDate: moment().add("7", "d").format(brazilFormatDate),
        startDate: moment().format(brazilFormatDate),
      },
      NEXT_15_DAYS: {
        endDate: moment().add("15", "d").format(brazilFormatDate),
        startDate: moment().format(brazilFormatDate),
      },
      NEXT_30_DAYS: {
        endDate: moment().add("30", "d").format(brazilFormatDate),
        startDate: moment().format(brazilFormatDate),
      },
      NO_INTERVAL: {
        endDate: "",
        // startDate: moment().format(brazilFormatDate),
        startDate: "",
      },
      LOCATOR: { endDate: moment().format(brazilFormatDate), startDate: moment().format(brazilFormatDate) },
    },
  });
  const [dataFlightsList, setDataFlightsList] = useState<IFlightOrder[]>([]);
  const [initialized, setInitialized] = useState(false);
  const [loading, setLoading] = useState(false);
  const { apiDomain } = useFlags();
  const api = VoeBizApi(apiDomain);

  const getMemberFlights = async (
    offset: string,
    limit: string,
    flightType: string,
    startDate: string,
    endDate: string,
  ) => {
    setLoading(true);
    const response = await api.memberFlights(offset, limit, flightType, startDate, endDate);
    setLoading(false);
    return response;
  };

  useEffect(() => {
    getMemberFlights("", "", "FUTURE", modal.filter.NO_INTERVAL.startDate, modal.filter.NO_INTERVAL.endDate).then(
      (data) => {
        setDataFlightsList(data.response.data.flightList);
        setInitialized(true);
      },
    );
  }, []);

  const toggleFilter = (status: boolean) => setModal((prevState) => ({ ...prevState, isOpenFilter: status }));
  const toggleDetail = (status: boolean) => setModal((prevState) => ({ ...prevState, isOpenDetail: status }));
  const setPeriod = (period: string) => setModal((prevState) => ({ ...prevState, period }));
  const setDataFlights = (flightList: []) => {
    setDataFlightsList(flightList);
  };
  const defaultFutureFlights = () => {
    getMemberFlights("", "", "FUTURE", modal.filter.NO_INTERVAL.startDate, modal.filter.NO_INTERVAL.endDate).then(
      (data) => {
        setDataFlightsList(data.response.data.flightList);
      },
    );
  };
  const defaultPastFlights = () => {
    getMemberFlights("0", "", "PAST", modal.filter.NO_INTERVAL.startDate, modal.filter.NO_INTERVAL.endDate).then(
      (data) => {
        setDataFlightsList(data.response.data.flightList);
      },
    );
  };
  const clearFlightsList = (type: string) => {
    setDataFlightsList([]);
    if (type === "Past") {
      setPeriod("NO_INTERVAL");
      return;
    }
    setPeriod("NO_INTERVAL");
  };
  return {
    toggleFilter,
    toggleDetail,
    modal,
    setPeriod,
    dataFlightsList,
    setDataFlightsList,
    setDataFlights,
    initialized,
    loading,
    defaultFutureFlights,
    defaultPastFlights,
    clearFlightsList,
  };
}
